<go-layout>
  <go-header go-layout-header>
    <ng-container go-header-right>
      <!-- Dark theme toggle hidden
      <div class="header__theme-switcher" (click)="toggleTheme()" [title]="isDarkTheme ? 'Switch to Light Theme' : 'Switch to Dark Theme'">
        <go-icon [icon]="isDarkTheme ? 'light_mode' : 'dark_mode'" [iconModifier]="isDarkTheme ? 'light' : 'dark'"></go-icon>
      </div>
      -->
      <go-action-sheet [shiftLeft]="true">
        <ng-container go-action-sheet__button>
          <go-icon-button buttonIcon="code">
          </go-icon-button>
        </ng-container>
        <ng-container go-action-sheet-content>
          <go-panel
          class="go-action-sheet-items"
            panelContent="GitHub"
            externalLink="https://github.com/mobi/goponents">
          </go-panel>
          <go-panel
          class="go-action-sheet-items"
            panelContent="NPM"
            externalLink="https://www.npmjs.com/package/goponents">
          </go-panel>
        </ng-container>
      </go-action-sheet>
    </ng-container>
  </go-header>
  <go-side-nav go-layout-nav [menuItems]="menuItems" [navAppDrawer]="navAppDrawer">
  </go-side-nav>
  <go-footer go-layout-footer>{{ date }}</go-footer>
</go-layout>
